import { useEffect } from 'react';

const useIntersectionObserver = (animationCompleted) => {
  useEffect(() => {
    if (!animationCompleted) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (isIntersecting) {
          target.classList.add("show_itens");
        } else {
          target.classList.remove("show_itens");
        }
      });
    });

    const scrollScaleElements = document.querySelectorAll(".scroll_scale");
    scrollScaleElements.forEach((scrollScale) => {
      observer.observe(scrollScale);
    });

    const scrollBottomElements = document.querySelectorAll(".scroll_bottom");
    scrollBottomElements.forEach((scrollBottom) => {
      observer.observe(scrollBottom);
    });

    const scrollTopElements = document.querySelectorAll(".scroll_top");
    scrollTopElements.forEach((scrollTop) => {
      observer.observe(scrollTop);
    });

    // Importante: desconectar o observer quando não for mais necessário
    return () => {
      observer.disconnect();
    };
  }, [animationCompleted]);
};

export default useIntersectionObserver;